// apps/client/src/utils/time.js

// Extrae 'HH:mm' sin aplicar zona horaria (evita desfaces por UTC)
export function extractHHmm(value) {
  if (!value) return null;
  const s = String(value);
  if (s.includes('T')) {
    // Ej: '1970-01-01T10:00:00.000Z' -> '10:00'
    const timePart = s.split('T')[1] || '';
    return timePart.slice(0, 5) || null; // HH:mm
  }
  // 'HH:mm:ss' o 'HH:mm'
  return s.slice(0, 5);
}

// Convierte 'HH:mm' (24h) a 'hh:mm a. m./p. m.' según norma en español
export function to12hWithAmPm(hhmm) {
  if (!hhmm) return '—';
  let [h, m] = hhmm.split(':').map(n => parseInt(n, 10));
  const esPM = h >= 12;
  h = h % 12 || 12; // 0 -> 12
  const hh12 = String(h).padStart(2, '0');
  const mm = String(m ?? 0).padStart(2, '0');
  const sufijo = esPM ? 'p. m.' : 'a. m.'; // español, con puntos y espacios
  return `${hh12}:${mm} ${sufijo}`;
}

export function toDDMMYYYY(value) {
  if (!value) return '—';
  const s = String(value);
  const ymd = s.includes('T') ? s.split('T')[0] : s;
  const [y, m, d] = ymd.split('-');
  if (!y || !m || !d) return ymd;
  return `${d}/${m}/${y}`;
}
